/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import * as React from 'react';

import cx from 'classnames';

import { NoServices } from 'components/NoServices/NoServices';

import { useServicesPage } from 'hooks/page/services/useServicesPage';

import { ClassicService } from './components/ClassicService';

import s from './ClassicServices.module.css';

const ClassicServices = () => {
  const {
    isListView,
    headingText,
    services,
    renderService,
    renderBookingHeader,
    renderSelectors,
    renderServiceProviderChangeModal,
    renderAutoBookingErrorModal,
    renderOfflineBookingModal,
    renderServiceOptionsModal,
    renderMaxAppointmentsWarning,
  } = useServicesPage();

  return (
    <>
      {renderBookingHeader()}
      <main className={cx(s.root, isListView ? s.listView : '')}>
        {services.length > 0 ? (
          <>
            <section className={s.servicesHeaderWrap}>
              {headingText && <h1 className={cx(s.title)}>{headingText}</h1>}
              {renderSelectors()}
            </section>
            <section className={s.list}>
              <h2 className="hidden">Services</h2>
              {services.map((service) => (
                <React.Fragment key={service.guid}>
                  {renderService(service, ClassicService)}
                </React.Fragment>
              ))}
            </section>
          </>
        ) : (
          <NoServices />
        )}
      </main>
      {renderAutoBookingErrorModal()}
      {renderOfflineBookingModal()}
      {renderServiceProviderChangeModal()}
      {renderMaxAppointmentsWarning()}
      {renderServiceOptionsModal()}
    </>
  );
};

export { ClassicServices };
